import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISwitchBusinessProfileRequest, ISwitchBusinessProfileResponse } from '../models/switch-to-another-business-profile.model';
import { fromSwitchToAnotherBusinessProfileActions } from '../actions';

export const switchToAnotherBusinessProfileFeatureKey = 'switchToAnotherBusinessProfile';

export interface SwitchToAnotherBusinessProfileState {
  loadSwitchToAnotherBusinessProfileRequest: ISwitchBusinessProfileRequest;
  loadSwitchToAnotherBusinessProfileResponse: ISwitchBusinessProfileResponse;
  loadSwitchToAnotherBusinessProfileFailure: IGenericError<ErrorResponse>;
}

export const initialState: SwitchToAnotherBusinessProfileState = {
  loadSwitchToAnotherBusinessProfileFailure: undefined,
  loadSwitchToAnotherBusinessProfileRequest: undefined,
  loadSwitchToAnotherBusinessProfileResponse: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfiles, (state, action) => ({
    ...state,
    loadSwitchToAnotherBusinessProfileRequest: action.request
  })),

  on(fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfilesSuccess, (state, action) => ({
    ...state,
    loadSwitchToAnotherBusinessProfileResponse: action.response
  })),

  on(fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfilesFailure, (state, action) => ({
    ...state,
    loadSwitchToAnotherBusinessProfileFailure: action.error
  })),

  on(fromSwitchToAnotherBusinessProfileActions.clearLoadSwitchToAnotherBusinessProfiles, (state, action) => ({
    ...state,
    loadSwitchToAnotherBusinessProfileResponse: undefined
  }))
);

export const switchToAntherBusinessProfileResponse = (state: SwitchToAnotherBusinessProfileState) =>
  state.loadSwitchToAnotherBusinessProfileResponse;
